import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile, updateProfile } from "../api/menupro.api";
import { uploadToImgBB } from "../api/imgbb";
import { getBusiness, logout, setBusiness } from "../store/menupro.store";
import "./profile.css";

export default function EditProfile() {
  const navigate = useNavigate();
  const biz = getBusiness();

  const [businessName, setBusinessName] = useState("");
  const [bio, setBio] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [newImageFile, setNewImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!biz?.id) {
      logout();
      navigate("/menupro/login");
      return;
    }
    load();
    // eslint-disable-next-line
  }, []);

  // previewUrl memory leak olmasın
  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  const load = async () => {
    try {
      const res = await getProfile(biz.id);
      const data = res.data || {};
      setBusinessName(data.businessName || "");
      setBio(data.bio || "");
      setProfileImage(data.profileImage || "");
    } catch (e) {
      console.log(e);
      alert("Profil yüklənmədi");
    }
  };

  const onPickImage = (e) => {
    const file = e.target.files?.[0] || null;

    // əvvəlki preview varsa revoke et
    if (previewUrl) URL.revokeObjectURL(previewUrl);

    setNewImageFile(file);

    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    } else {
      setPreviewUrl("");
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      let finalImage = profileImage;
      if (newImageFile) {
        finalImage = await uploadToImgBB(newImageFile);
      }

      const res = await updateProfile(biz.id, {
        businessName: businessName.trim(),
        bio: bio.trim(),
        profileImage: finalImage,
      });

      // localStorage yenilə
      setBusiness(res.data);

      alert("Profil yeniləndi");
      navigate("/menupro/dashboard");
    } catch (e) {
      console.log(e);
      alert("Xəta baş verdi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-card">
        <h2 className="profile-title">Profilin redaktəsi</h2>

        <div className="avatar-wrap">
          <img
            className="avatar"
            src={previewUrl || profileImage || "https://img.icons8.com/fluent/1200/shop.jpg"}
            alt=""
          />

          <label className="upload-btn">
            Şəkil seç
            <input type="file" hidden accept="image/*" onChange={onPickImage} />
          </label>

          {newImageFile && <p className="hint">Seçilmiş fayl: {newImageFile.name}</p>}
        </div>

        <div className="field">
          <label>Biznes adı</label>
          <input
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            placeholder="Biznes adı"
          />
        </div>

        <div className="field">
          <label>Bioqrafiya</label>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            placeholder="Qısa məlumat yazın..."
          />
        </div>

        <button className="save-btn" onClick={handleSave} disabled={saving}>
          {saving ? "Yüklənir..." : "Yadda saxla"}
        </button>

        <button className="back-btn" onClick={() => navigate("/menupro/dashboard")}>
          Geri qayıt
        </button>
      </div>
    </div>
  );
}

